import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { Form } from 'semantic-ui-react';
import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";

const EmailAddress = ({ allowMultipleEmailAddresses, required, onChange, emailAddress, emailAddressOptions }) => {
	const _emailAddress = useMemo(() => {
		if (allowMultipleEmailAddresses) {
			if (emailAddress === '') {
				return [];
			} else {
				return emailAddress.split(';');
			}
		}

		return emailAddress;
	}, [allowMultipleEmailAddresses, emailAddress]);

	if (allowMultipleEmailAddresses) {
		return (
			<Form.Field required={required}>
				<label>Email Address</label>
				<TagsInput value={_emailAddress} inputProps={{ placeholder: 'Add an Email Address' }} onlyUnique onChange={(emails) => onChange(emails.join(';'))} />
			</Form.Field>
		);
	} else {
		if (emailAddressOptions && emailAddressOptions.length > 1) {
			return <Form.Field>
                <label>Email Address</label>
                <Combobox name='emailAddress' data={emailAddressOptions || []} dropUp hideEmptyPopup onChange={(value) => onChange(value)} value={emailAddress} type="email" />
            </Form.Field> 
		} else {
			return <Form.Input name='emailAddress' label='Email Address' value={_emailAddress || ''} onChange={(_, { value }) => onChange(value)} required={required} type="email" />;
		}
	}
};

EmailAddress.propTypes = {
	allowMultipleEmailAddresses: PropTypes.bool,
	required: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	emailAddress: PropTypes.any.isRequired,
};

export default EmailAddress;
